<template>
  <div>

    <div class="container">
      <!-- 左侧操作列表 -->
      <div class="left" id="left">
        <ul>
          <span>操作列表</span>
          <li @click="tzck" :style="step==1? objC : ''">通知查看</li>
          <li @click="tdjz" :style="step==2? objC : ''">投递进展</li>
          <li @click="scjl" :style="step==3? objC : ''">收藏记录</li>
          <li @click="zhsz" :style="step==4? objC : ''">账号设置</li>
          <li @click="zkzdy" :style="step==5? objC : ''">打印准考证</li>
          <li @click="bmbdy" :style="step==6? objC : ''">打印报名表</li>
        </ul>
      </div>

      <!-- 右侧 -->
      <div class="right">
         <!-- 1.通知查看 -->
        <div v-if="step==1">
          <!-- 标题 -->
          <div class="title">
            <h4>通知查看</h4>
          </div>
          <!-- 内容 -->
           <!---->
           <!-- <a-collapse-panel key="1" :header="'\xa0\xa0\xa0\xa0'+ '\xa0\xa0\xa0\xa0'+item.NOTICECONTENT+'\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0'+'答复：'+item.ANSWERCONTENT ? '无' : item.ANSWERCONTENT" :style="customStyle" v-for="(item,i) in tongzhiList" :key="i"> -->
    <a-collapse default-active-key="1" :bordered="false" accordion @change="subText=''">
      <a-collapse-panel key="1" :header="`\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0${item.NOTICECONTENT}\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\n\xa0\xa0\xa0答复：${item.ANSWERCONTENT==null ? '无' : item.ANSWERCONTENT}`" :style="customStyle" v-for="(item,i) in tongzhiList" :key="i">


        <div class="txt">
            <textarea maxlength="50" placeholder="请输入在50字以内" cols="30" rows="10" class="lists2" v-model="subText"></textarea>
            <div class="headerTop2">
              <button class="btn1" @click="applyOk(item.NOTICEID,item.ANSWERCONTENT,item)">确认</button>
              <button class="btn2" @click="clear">取消</button>
            </div>
          </div>
      </a-collapse-panel>
    </a-collapse>




        </div>


        <!-- 2.简历投递 -->
        <div v-if="step==2">
          <div class="title">
            <h4>简历投递</h4>
          </div>

           <!-- 数据 -->
          <a-table :columns="jlcolumns" :data-source="jldata"   :pagination="false">

          </a-table>

        </div>


        <!-- 3.收藏记录 -->
        <div v-if="step==3">
          <div class="title">
            <h4>收藏记录</h4>
          </div>

           <!-- 数据 -->
          <a-table :columns="sccolumns" :data-source="scdata" :pagination="false">
             <span slot="sq" slot-scope="text,record">
              <div class="df sqsc">
                <a-button type="primary"  icon="form" @click="sq(record)"></a-button>
              </div>
            </span>
            <span slot="qx" slot-scope="text,record">
              <div class="df sqsc">
                <a-button type="primary"  icon="rollback" @click="canelsc(record)"></a-button>
              </div>
            </span>
          </a-table>
        </div>


        <!-- 4.账号设置 -->
        <div v-if="step==4">
          <div class="title">
            <h4>账号设置</h4>
          </div>

          <ul class="step3ul">
            <li >
              <div><img src="../../../assets/b-youxiang.png" alt=""></div>
              <a @click="toyx">编辑邮箱</a>
            </li>
            <li>
              <div><img src="../../../assets/b-mima.png" alt=""></div>
              <a @click="tomm">修改密码</a>
            </li>
            <li>
              <div><img src="../../../assets/b-shouji.png" alt=""></div>
              <a @click="tosj">编辑手机</a>
            </li>
          </ul>
        </div>


        <!-- 5.打印准考证 -->
        <div v-if="step==5">
          <div class="title">
            <h4>打印准考证</h4>
          </div>

          <a-table :columns="zkzcolumns" :data-source="zkzdata"  :pagination="false">
            <span slot="print" slot-scope="text,record">
              <div class="df sqsc">
                <a-button type="primary"  icon="vertical-align-bottom" @click="printzkz(record)"></a-button>
              </div>
            </span>
          </a-table>
        </div>


        <!-- 6.打印报名表 -->
        <div v-if="step==6">
          <div class="title">
            <h4>打印报名表</h4>
          </div>

          <a-table :columns="bmbcolumns" :data-source="bmbdata"  :pagination="false">
            <span slot="print" slot-scope="text,record">
              <div class="df sqsc">
                <a-button type="primary"  icon="vertical-align-bottom" @click="printbmb(record)"></a-button>
              </div>
            </span>
          </a-table>
        </div>


      </div>

    </div>


    <gwbb :visible.sync="visible" :gwbbData="gwbbData" :ksplace="ksplace"></gwbb>

  </div>
</template>


<script>
var configLink = require('../../../../config/index')

import gwbb from '../../zkzw/compos/gwbb.vue'
import { config } from '../../encryptionConfig.js'
export default {
  components:{
      gwbb
    },
  data(){
    return{
      //空格
      br:'                   ',

      // 传给对话框的数据
      gwbbData:{},

      ksplace:[],

      //折叠面板样式
      customStyle:'background: #E3EEFF;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden',

      //打开visible
      visible:false,

      // 左侧操作列表数据
      todoList:['通知查看','投递进展','收藏记录','账号设置','打印准考证','打印报名表'],

      //表示点击了第几项
      step:1,
       objC: {backgroundColor: '#FFF1DD'},

      // 简历表头
      jlcolumns:[
        {
          title: '批次名称',
          dataIndex: 'BATCHNAME',
          key: 'BATCHNAME',
        },
        {
          title: '单位名称',
          dataIndex: 'B0101',
          key: 'B0101',
        },
        {
          title: '职位名称',
          dataIndex: 'JOBNAME',
          key: 'JOBNAME',
        },
        {
          title: '参加考试地点名称',
          dataIndex: 'PLACENAME',
          key: 'PLACENAME',
        },
        {
          title: '投递时间',
          dataIndex: 'APPLYTIME',
          key: 'APPLYTIME',
        }
      ],
      // 简历记录表格数据
      jldata:[],


      //收藏表头
      sccolumns:[
         {
          title: '单位名称',
          dataIndex: 'B0101',
          key: 'B0101',
        },
         {
          title: '职位名称',
          dataIndex: 'JOBNAME',
          key: 'JOBNAME',
        },
         {
          title: '专业要求',
          dataIndex: 'JOBREQUIRE_PROFESSION',
          key: 'JOBREQUIRE_PROFESSION',
        },
        {
          title: '学历要求',
          dataIndex: 'JOBREQUIRE_DEGREE',
          key: 'JOBREQUIRE_DEGREE',
        },
        {
          title: '人数',
          dataIndex: 'JOBREQUIRE_NUMBER',
          key: 'JOBREQUIRE_NUMBER',
        },
        {
          title: '收藏时间',
          dataIndex: 'COLLECTTIME',
          key: 'COLLECTTIME',
        },
        {
          title: '申请',
          dataIndex: 'sq',
          key: 'sq',
           scopedSlots: { customRender: 'sq' },
        },
        {
          title: '取消收藏',
          dataIndex: 'qx',
          key: 'qx',
          scopedSlots: { customRender: 'qx' },
        },
      ],
      //收藏表格数据
      scdata:[],

      //打印准考证表头
      zkzcolumns:[
        {
          title: '批次名称',
          dataIndex: 'BATCHNAME',
          key: 'BATCHNAME',
        },
         {
          title: '单位名称',
          dataIndex: 'B0101',
          key: 'B0101',
        },
         {
          title: '报考岗位',
          dataIndex: 'JOBNAME',
          key: 'JOBNAME',
        },
         {
          title: '考试开始时间',
          dataIndex: 'EXAMSTART',
          key: 'EXAMSTART',
        },
         {
          title: '考试结束时间',
          dataIndex: 'EXAMEND',
          key: 'EXAMEND',
        },
        {
          title: '地点',
          dataIndex: 'EXAMADRESS',
          key: 'EXAMADRESS',
        },
        {
          title: '打印准考证',
          dataIndex: 'print',
          key: 'print',
          scopedSlots: { customRender: 'print' },
        },
      ],
      //打印准考证表格数据
      zkzdata:[
      ],


      // 打印报名表表头
      bmbcolumns:[
         {
          title: '批次名称',
          dataIndex: 'BATCHNAME',
          key: 'BATCHNAME',
        },
         {
          title: '单位名称',
          dataIndex: 'B0101',
          key: 'B0101',
        },
         {
          title: '报考岗位',
          dataIndex: 'JOBNAME',
          key: 'JOBNAME',
        },
         {
          title: '姓名',
          dataIndex: 'A0101',
          key: 'A0101',
        },
         {
          title: '打印报名表',
          dataIndex: 'print',
          key: 'print',
          scopedSlots: { customRender: 'print' },
        },
      ],
      //打印报名表表格数据
      bmbdata:[],

      //通知查看表头
      //通知查看列表
      tongzhiList:[],

      //通知查看回复
      subText:'',

      //头像信息
        a01109:'',
    }

  },


  methods:{
    changeStep(i){
      // console.log(i);
      this.step=i
    },
    toyx(){
      this.$router.push('/bjxg/bjyx')
    },
    tosj(){
      this.$router.push('/bjxg/xgsj')
    },
    tomm(){
      this.$router.push('/bjxg/xgmm')
    },

    //点击了申请
    sq(r){
      console.log(r);
      if(!sessionStorage.getItem('BDSOFT-TOKEN')) return this.$message.warning('请先登录')

      if(!this.a01109) return this.$message.error('请先上传照片')

      // var issq = this.jldata.some(i => {
      //   return i.JOBID===r.JOBID
      // });
      // if(issq) return this.$message.error('您已经申请过该职位了')

      // var ispcsq = this.jldata.some(i => {
      //   return i.BATCHID===r.BATCHID
      // });
      // if(ispcsq) return this.$message.error('您已超过当前批次申报数，无法再申报')

      this.post({
        url: 'allowApplyNum',
        data: {
          A00: sessionStorage.getItem('aabb'),
          BATCHID: r.BATCHID,
          JOBID: r.JOBID,
        }
      },(res)=>{
        console.log(res);
        if(res.message=="正常填报！"){
          this.gwbbData=r

          this.get({
            url:'getPlaceid',
            data:{
              batchid:r.BATCHID
            }
          },(res)=>{
            console.log(res);
            console.log(999);
            if(res.code==200){
              this.ksplace=res.data
            }
          })

          this.visible=true
        }else if(res.message=="已申请过该职位，不能重复申请！"){
          this.$message.error(res.message)
        } else{
          this.$message.error(res.message)
        }
      })
    },

    //获取个人简历的照片信息
    //获取个人简历信息
    getBasicInfo(){
      this.post({
        url:'getBasicInfo',
        data:{
          a00:sessionStorage.getItem('aabb'),
        }
      },(res)=>{
        this.a01109 = res.data.zdyxa0106

      })
    },

    //获取通知列表
    myNoticeview(){
      this.post({
          url: 'myNoticeview',
          data:{
            A00: sessionStorage.getItem('a0d')
          }
      }, (res) => {
        console.log(9999);
        console.log(res);
        this.tongzhiList=res.data
      })
    },

    //简历投递进展纪录
    deliveryProgress(){
      this.post({
          url: 'deliveryProgress',
      }, (res) => {
        // console.log(res);
        // console.log(999);
        this.jldata=res.data
      })
    },

    //获取收藏职位列表
    collectionRecord(){
      this.post({
          url: 'collectionRecord',
      }, (res) => {
        // console.log(res);
        // console.log(999);
        this.scdata=res.data
      })
    },

    //点击了取消收藏
    canelsc(r){
      this.post({
          url: 'removeCollectionRecord',
          data:{
            collectjobid:r.ID
          }
      }, (res) => {
        this.$message.success('取消收藏成功')
        this.collectionRecord()
      })
    },

    //打开页面获取准考证详情
    admissionTicket(){
      this.post({
        url:'admissionTicket',
      },(res)=>{
        if(res.code==200){
          this.zkzdata=res.data
        }
      })
    },

    //打开页面获取报名表详情
    getByIDBmb(){
      this.post({
        url:'getByIDBmb',
      },(res)=>{
        if(res.code==200){
          this.bmbdata=res.data
        }
      })
    },

    //点击了打印准考证
    printzkz(scope){
      console.log(scope);
      this.post({
        url: 'admissionTicketLog',
        data: {
          BATCHID: scope.BATCHID,
          BATCHNAME: scope.BATCHNAME,
          JOBID: scope.JOBID,
          JOBNAME: scope.JOBNAME,
          RID: scope.RID
        }
      }, (res)=>{
        console.log(res);
      })

      var tk=sessionStorage.getItem('BDSOFT-TOKEN')
      window.open(`/dev-api/report/exportWord/export?theme=none&templateDir=template/dyzkz/%E6%89%93%E5%8D%B0%E5%87%86%E8%80%83%E8%AF%81.doc&isDownLoad=1&ROOMID=${scope.ROOMID}&BATCHID=${scope.BATCHID}&A00=${scope.A00}&PLACEID=${scope.PLACEID}&JOBID=${scope.JOBID}&saveAsFileName=%E6%89%93%E5%8D%B0%E5%87%86%E8%80%83%E8%AF%81&BDSOFT-TOKEN=${tk}&key=${config.key}&encryption=${config.encryption}`)
    },

    //点击了打印报名表
     printbmb(scope){
       var tk=sessionStorage.getItem('BDSOFT-TOKEN')
       window.open(`/dev-api/report/exportWord/export?theme=none&templateDir=template/dybmb/打印报名表.doc&isDownLoad=1&A00=${scope.A00}&BATCHID=${scope.BATCHID}&JOBID=${scope.JOBID}&saveAsFileName=打印报名表&BDSOFT-TOKEN=${tk}&key=${config.key}&encryption=${config.encryption}`)
    },

    dbn(i){
      console.log(i);

    },

    //回复消息
    applyOk(id,content,item){
      console.log(item);
      var that = this
      if(content){
        this.$confirm({
        title: '您已经回复过这条消息了，再次回复会覆盖之前的回复信息，确定再次回复吗?',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          that.post({
            url:'setNoticeAn',
            data:{
              answercontent: that.subText,
              noticeid: id,
              answerid: item.ANSWERID
            }
          },(res)=>{
            if(res.code==200){
              that.myNoticeview()
              console.log(res);
            }
          })
        },
        onCancel() {},
      })
      } else {
        this.post({
          url:'setNoticeAn',
          data:{
            answercontent:this.subText,
            noticeid:id
          }
        },(res)=>{
          if(res.code==200){
            this.myNoticeview()
            console.log(res);
          }
        })
      }



    },

    //點擊了左側的通知查看
    tzck(){
      this.myNoticeview()
      this.step=1
    },
    //點擊了左側的投遞進展
    tdjz(){
      this.deliveryProgress()
      this.step=2
    },
    scjl(){
      this.collectionRecord()
      this.step=3
    },
    zhsz(){
      this.step=4
    },
    bmbdy(){
      this.getByIDBmb()
      this.step=6
    },
    zkzdy(){
      this.admissionTicket()
      this.step=5
    },

    //点击取消
    clear(){
      this.subText=''
    }
  },
  created(){
    this.getBasicInfo()
    this.myNoticeview()
    //获取到传参的第几部
    // console.log(this.$route.query.step);
    if(!this.$route.query.step){
      this.step==1
    }else if(this.$route.query.step==2){
      this.step=2
      this.deliveryProgress()
    }else if(this.$route.query.step==3){
      this.step=3
      this.collectionRecord()
    }

  }
}
</script>

<style scoped>
.container{
  display: flex;
}

li{
  list-style: none;
}

.left{
  width: 200px;
  font-size: 14px;
}

.left ul li{
    font-size: 14px;
    color: #706e6e;
    background-color: #fff;
    height: 39px;
    line-height: 40px;
    border-bottom: 1px solid #d2d2d2;
    border-left: 1px solid #d2d2d2;
    border-right: 1px solid #d2d2d2;
    cursor: pointer;
    padding-left: 15px;
}

.left ul span{
  display: flex;
  font-size: 16px;
  background-color: #cc0000;
  color: #fff;
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
}



.right{
  margin-left: 36px;
  border: 1px solid #c1d7f9;
  width: 660px;
  background-color: #e3eeff;
}

.title{
  background-color: #fff;
  text-align: center;
  border-bottom: 1px solid #e3eeff;
}

.title h4{
  display: inline-block;
  width: 110px;
  height: 30px;
  line-height: 30px;
  background-color: #cc0000;
  border-radius: 20px;
  color: #fff;
  margin-top: 8px;
}


.step3ul{
  display: flex;
  margin-top: 50px;
  margin-left: 20px;
}

.step3ul li{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.step3ul li div{
    width: 122px;
    height: 122px;
    border: 1px solid #CECECE;
    border-radius: 10px;
    margin-left: 60px;
    text-align: center;
    line-height: 122px;
}

.step3ul li a{
    width: 122px;
    height: 30px;
    background: #3490E5;
    color: #ffffff;
    text-align: center;
    line-height: 30px;
    border-radius: 10px;
    float: left;
    margin-left: 60px;
    margin-top: 20px;
    text-indent: 8px;
    padding-left: 2px;
}


.tzggMore{
  padding-bottom: 80px;
}
.tzggMore li{
    border-bottom: 1px dashed #797979;
    height: 47px;
    position: relative;
    cursor: pointer;
    line-height: 65px;
}

.ttl{
    width: 600px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    font-size: 16px;
    color: #000;
    padding-left: 20px;
}
.dates{
    color: #939393;
    position: absolute;
    right: 0;
    font-size: 16px;
    color: #939393;
    padding-right: 20px;
}

.headerTop{
  height: 30px;
  background-color: #F7FFF3;
  margin: 20px 20px 0;
  border: 1px solid #ACC3E9;
  border-bottom:0
}

.lists{
  height: 150px;
  background-color: #fff;
  margin:0 20px;
  border: 1px solid #ACC3E9;
}

.huifu{
  color: #6796E6;
  cursor: pointer;
  margin-left: 510px;
  margin-top: 5px;
}

.lists2{
  display: block;
  height: 150px;
  width: 93.6%;
  border: none;
  background-color: #fff;
  margin:10px 20px 0 20px;
  outline:none;resize:none;
}

.headerTop2{
  height: 30px;
  background-color: #F7FFF3;
  margin:0 20px 30px 20px;
  border-bottom:0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.headerTop2 button{
  cursor: pointer;
}

.btn1{
  border: none;
  background-color: #3490E5;
  width: 50px;
  height: 20px;
  margin-right: 10px;
}

.btn2{
  border: none;
  background-color: #ccc;
  width: 50px;
  height: 20px;
}

.bigbox{
  width: 90%;
  margin: auto;
  border-bottom: 2px solid #ACC3E9;
  margin-bottom: 20px;
}

/deep/ .ant-collapse-header{
  background-color: #fff;
  height: 150px;
  margin: 0 35px;
  padding-left: 0 !important;
    border: 1px solid #ACC3E9;
}

/deep/ .ant-collapse-header i{
  display: none!important;
}

/deep/ td{
  background-color: #fff;
  text-align: center !important;
  padding: 5px 3px !important; ;
  max-width: 100px;
  white-space:nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/deep/ .ant-table-pagination.ant-pagination {
    float: left;
}

/deep/ th {
    text-align: center !important;
    padding: 5px 3px !important;
}

/deep/ .ant-btn-primary{
  color: #1890ff;
  background-color: white;
  border-color: white;
  box-shadow: none;
}

/deep/ .ant-collapse-item{
  margin-bottom: 0!important;
  padding-bottom: 20px;
}

div /deep/ .ant-collapse-header{
  word-break:break-all;
}

</style>



// WEBPACK FOOTER //
// src/views/grzx/pages/index.vue